export default __webpack_public_path__ + "static/media/investmentmenuicon.fc5da8d3.svg";